import { Button } from '@heidi/design-system/button';
import { cn } from '@heidi/utils';
import { ChevronDown } from 'lucide-react';
import { useIntl } from 'react-intl';

import { projectScrollToBottomButtonMessages } from './ProjectScrollToBottomButton.messages';

interface ProjectScrollToBottomButtonProps {
  isVisible: boolean;
  onClick: () => void;
  className?: string;
}

/**
 * Jump-to-bottom affordance for the Work transcript. The transcript pins a
 * fresh question to the top and lets the reply stream in below the fold, so
 * this is how a reader goes down to what has arrived.
 *
 * Kept mounted and faded out rather than unmounted so the fade reads as an
 * appearance rather than a pop, and taken out of the tab order while hidden.
 */
export const ProjectScrollToBottomButton = ({
  isVisible,
  onClick,
  className,
}: ProjectScrollToBottomButtonProps) => {
  const intl = useIntl();

  return (
    <div
      className={cn(
        'absolute inset-x-0 bottom-3 z-20 flex justify-center transition-opacity duration-100 ease-out',
        isVisible ? 'pointer-events-auto opacity-100' : 'pointer-events-none opacity-0',
        className
      )}
    >
      <Button
        variant="outline"
        size="sm"
        iconOnly
        onClick={onClick}
        className="rounded-full border border-border bg-surface shadow-sm"
        aria-label={intl.formatMessage(projectScrollToBottomButtonMessages.label)}
        tabIndex={isVisible ? 0 : -1}
        data-testid="project-chat-scroll-to-bottom"
      >
        <ChevronDown className="text-text-secondary" />
      </Button>
    </div>
  );
};
